import { ObservableStorage } from './observable-storage';

export class WantsToBeGuestStorage extends ObservableStorage<boolean> {
	constructor() {
		super('wants-to-be-guest', sessionStorage);
	}
}
